<div class="card" *ngIf="loading">
    <div class="card-body flex justify-center" style="margin-top: 20px;">
        <app-preloader ></app-preloader>
    </div>
</div>
<div class="grid grid-cols-12 gap-6" *ngIf="!loading">
    <div class="lg:col-span-4 md:col-span-12 sm:col-span-12 col-span-12">
        <div class="card mb-6">
            <div class="card-body">
                <div class="pb-5">
                    <h4 class="text-xl mb-5">About me</h4>
                    <!-- <p class="text-dark dark:text-darklink font-medium">Hello, I’m Mike Nielsen.
                            I’m a professional who designs, develops, tests, and maintains software
                            applications and systems.</p> -->
                </div>
                <div class="pt-5 border-t">
                    <!-- <h5 class="text-xl mb-5">Contact</h5> -->
                    <ul class="mb-0">
                        <li class="flex items-center mb-5 gap-4">
                            <div
                                class="bg-lighterror dark:bg-darkerror h-10 w-10 rounded-full flex items-center justify-center">
                                <i class="ti ti-user text-error text-xl"></i>
                            </div>
                            <div>
                                <h6 class="text-fs_15 mb-1">Name</h6>
                                <p class="text-darklink font-medium">{{ userDetails.name }}</p>
                            </div>
                        </li>
                        <!-- <li class="flex items-center mb-5 gap-4">
                                <div
                                    class="bg-lighterror dark:bg-darkerror h-10 w-10 rounded-full flex items-center justify-center">
                                    <i class="ti ti-phone text-error text-xl"></i>
                                </div>
                                <div>
                                    <h6 class="text-fs_15 mb-1">Call</h6>
                                    <p class="text-darklink font-medium">(123) 456-7890</p>
                                </div>
                            </li> -->
                        <li class="flex items-center mb-5 gap-4">
                            <div
                                class="bg-lightsuccess dark:bg-darksuccess h-10 w-10 rounded-full flex items-center justify-center">
                                <i class="ti ti-mail text-success text-xl"></i>
                            </div>
                            <div>
                                <h6 class="text-fs_15 mb-1">Email</h6>
                                <p class="text-darklink font-medium">{{ userDetails.email }}</p>
                            </div>
                        </li>
                        <li class="flex justify-center mb-5 gap-4">
                            <div class="flex justify-center gap-3 mt-4 mb-4">
                                <button
                                    class="px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    routerLink="/portal/user/{{userId}}/locations">
                                    View all my locations
                                </button>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lg:col-span-8 md:col-span-12 sm:col-span-12 col-span-12">
        <div class="grid grid-cols-12 gap-6 mb-6">
            <div class="lg:col-span-4 md:col-span-12 sm:col-span-12 col-span-12">
                <div class="card">
                    <div class="card-body">
                        <div class="flex items-center gap-4">
                            <div
                                class="bg-lightsuccess dark:bg-darksuccess h-12 w-12 rounded-full flex items-center justify-center">
                                <i class="ti ti-layout-grid-add text-success text-2xl"></i>
                            </div>
                            <div>
                                <h6 class="text-xl">{{ userDetails.devices.length }}</h6>
                                <p class="text-fs_15 font-medium">Devices</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:col-span-4 md:col-span-12 sm:col-span-12 col-span-12">
                <div class="card">
                    <div class="card-body">
                        <div class="flex items-center gap-4">
                            <div
                                class="bg-lightprimary dark:bg-darkprimary h-12 w-12 rounded-full flex items-center justify-center">
                                <i class="ti ti-template text-primary text-2xl"></i>
                            </div>
                            <div>
                                <h6 class="text-xl">{{ userDetails.subscriptions.length }}</h6>
                                <p class="text-fs_15 font-medium">Subscriptions</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lg:col-span-4 md:col-span-12 sm:col-span-12 col-span-12">
                <div class="card">
                    <div class="card-body">
                        <div class="flex items-center gap-4">
                            <div
                                class="bg-lighterror dark:bg-darkerror h-12 w-12 rounded-full flex items-center justify-center">
                                <i class="ti ti-id text-error text-2xl"></i>
                            </div>
                            <div>
                                <h6 class="text-xl">{{ userDetails.themes.length }}</h6>
                                <p class="text-fs_15 font-medium">Owned Themes</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h6 class="text-lg text-gray-500 font-semibold mb-6">Latest 5 activies</h6>
                <div class="relative overflow-x-auto" *ngIf="userDevices.length > 0">
                    <table class="text-left w-full whitespace-nowrap text-sm text-gray-500">
                        <thead>
                            <tr class="text-sm">
                                <th scope="col" class="p-4 font-semibold">Device ID</th>
                                <th scope="col" class="p-4 font-semibold">Device</th>
                                <th scope="col" class="p-4 font-semibold">Itagtip Version</th>
                                <th scope="col" class="p-4 font-semibold">Last Updated</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let device of userDevices | slice: 0:5 ">
                                <td class="p-4 text-sm">
                                    <div class="flex gap-6 items-center">
                                        <div class="flex flex-col gap-1 text-gray-500">
                                            <h3 class=" font-bold">{{ device._id }}</h3>
                                        </div>
                                    </div>
                                </td>
                                <td class="p-4">
                                    <h3 class="font-medium">{{ device.manufacturer | titlecase }}
                                        ({{device.operatingSystem}} - v{{device.operatingSystemVersion}}) </h3>
                                </td>
                                <td class="p-4">
                                    <h3 class="font-medium">Itagtip v{{ device.appVersion || 0.0}}</h3>
                                </td>
                                <td class="p-4">
                                    <h3 class="font-medium">{{ device.installDate | date:"medium"}}</h3>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="4">
                                    <div class="flex justify-center gap-3 mt-4 mb-4">
                                        <button
                                            class="px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                            routerLink="/portal/user/{{userId}}/history">
                                            View all
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="flex justify-center" *ngIf="userDevices.length === 0">
                    <img src="./assets/images/profile/no-record-found.png" alt="" class="w-100px h-100px">
                </div>
            </div>
        </div>
    </div>
</div>